import { __assign, __rest } from "tslib";
import React from 'react';
import { Drawer as MaterialDrawer, makeStyles, createStyles, } from '@material-ui/core';
var usePaperStyles = makeStyles(function (theme) {
    return createStyles({
        root: {
            boxShadow: '0px 0px 4px 0px rgba(0,0,0,0.08)',
        },
    });
});
var useBackdropStyles = makeStyles(function (theme) {
    return createStyles({
        root: {
            background: 'transparent',
        },
    });
});
export var Drawer = function (_a) {
    var children = _a.children, props = __rest(_a, ["children"]);
    var backdropClasses = useBackdropStyles({});
    var paperClasses = usePaperStyles({});
    return (React.createElement(MaterialDrawer, __assign({ PaperProps: { classes: paperClasses }, ModalProps: { BackdropProps: { classes: backdropClasses } } }, props), children));
};
//# sourceMappingURL=Drawer.js.map